import { render, staticRenderFns } from "./BlogHome.vue?vue&type=template&id=be8c3ff8&scoped=true"
import script from "./BlogHome.vue?vue&type=script&lang=js"
export * from "./BlogHome.vue?vue&type=script&lang=js"
import style0 from "./BlogHome.vue?vue&type=style&index=0&id=be8c3ff8&prod&lang=scss&scoped=true"
import style1 from "./BlogHome.vue?vue&type=style&index=1&id=be8c3ff8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8c3ff8",
  null
  
)

export default component.exports